import { render } from "./PanelContainer.vue?vue&type=template&id=44700dac&scoped=true"
const script = {}

import "./PanelContainer.vue?vue&type=style&index=0&id=44700dac&lang=less&scoped=true"

import exportComponent from "/builds/toyota/bo/merchant-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44700dac"]])

export default __exports__